import { BehaviorSubject, Observable } from 'rxjs';
import { Messages } from './messages.models';
import { DataSource } from '@angular/cdk/collections';
import { MessagesService } from './messages.service';

export class MessagesDataSource implements DataSource<Messages> {
  messages = new BehaviorSubject<Messages[]>([]);
  loading = new BehaviorSubject<boolean>(false);
  rowCount = new BehaviorSubject<number>(0);
  constructor(private messageService: MessagesService) {}
  connect(): Observable<Messages[]> {
    return this.messages.asObservable();
  }

  disconnect(): void {
    this.messages.complete();
    this.loading.complete();
    this.rowCount.complete();
  }

  loadMessages = async (pageIndex: number, pageSize: number) =>
    await this.getPagedResults(pageIndex, pageSize);

  filterByMessageType = async (pageIndex: number, pageSize: number, messageType: string) =>
    await this.getPagedResults(pageIndex, pageSize, messageType);

  private async getPagedResults(pageIndex: number, pageSize: number, messageType: string = null) {
    this.loading.next(true);
    const pagedResult = await this.messageService.getMessages(pageIndex, pageSize, messageType);
    this.messages.next(pagedResult.results);
    this.rowCount.next(pagedResult.rowCount);
    this.loading.next(false);
  }
}
